import { Field } from "@app/types/Cue";
import { Type } from "@app/types/enums";

export type SubHeadingProps = { className?: string; fields: Field[] };

export default function SubHeading({
  className,
  fields,
}: SubHeadingProps): React.ReactElement {
  const text = fields.find((field) => field.name === Type.SubHead)?.value;
  const heading = fields.find((field) => field.name === Type.Headings)?.value;

  const HeadingTag = heading as "span" | "h2" | "h3" | "h4" | "h5" | "h6";

  return (
    <HeadingTag
      className={className}
      data-story-element={Type.SubHead}
      data-testid="sub-heading-component"
    >
      {text}
    </HeadingTag>
  );
}
